module.exports = __webpack_public_path__ + "static/img/170324149236586479143633.525bc39.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/work/20231222/170324149236586479143633.jpeg
// module id = 11E7
// module chunks = 7